import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { LuMail } from "react-icons/lu";
import api from "../../api/axios";
import Navbar from "../../components/companyLandingComponents/Navbar/Navbar";
import BottomFooter from "../../components/Footer/BottomFooter/BottomFooter";
import "./auth.css";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setIsError(false);
    setLoading(true);

    try {
      const res = await api.post("/api/forgot-password", { email });
      setMessage(
        res.data.message ||
          "If that email exists, we sent a reset link."
      );
      setIsError(false);
      toast.success("Check your email for a reset link.");
    } catch (err) {
      const apiMessage =
        err.response?.data?.message ||
        "Unable to send reset link. Please try again.";
      setMessage(apiMessage);
      setIsError(true);
      toast.error(apiMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#f8f9fa" }}>
      <Navbar />

      <div
        className="position-fixed start-0 end-0 top-0 bottom-0"
        style={{
          background:
            'url("/assets/images/iconicback.jpg") center/cover no-repeat',
          zIndex: 0,
        }}
      ></div>

      <div
        className="container position-relative d-flex align-items-center justify-content-center"
        style={{
          zIndex: 1,
          minHeight: "calc(100vh - 80px)",
          marginTop: "15px",
        }}
      >
        <div className="row justify-content-center w-100">
          <div className="col-xxl-8 col-lg-10">
            <div
              className="card border-0 shadow-lg overflow-hidden"
              style={{
                borderRadius: "15px",
                backdropFilter: "blur(10px)",
                backgroundColor: "rgba(255, 255, 255, 0.98)",
              }}
            >
              <div className="row g-0">
                <div
                  className="col-lg-5 d-none d-lg-flex flex-column align-items-center justify-content-center text-white p-5"
                  style={{ backgroundColor: "#2e86de" }}
                >
                  <img
                    src="/assets/images/logo.png"
                    alt="logo"
                    className="img-fluid mb-4"
                    style={{ maxWidth: "180px" }}
                  />
                  <h3 className="fw-bold text-center welcome-text">
                    Forgot Password?
                  </h3>
                  <p className="text-center opacity-75 small">
                    Enter your account email and we will send you a secure link
                    to reset your password.
                  </p>
                </div>

                <div className="col-lg-7 p-4 p-md-5">
                  <div className="d-lg-none text-center mb-4">
                    <img
                      src="/assets/images/logo.png"
                      alt="logo"
                      style={{ width: "120px" }}
                    />
                  </div>

                  <h2 className="fw-bold text-dark mb-1">Reset via Email</h2>
                  <p className="text-muted mb-4">
                    We will email you a link that expires in 60 minutes.
                  </p>

                  <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                      <label className="form-label small fw-semibold">
                        Email Address
                      </label>
                      <div className="input-group custom-input-group">
                        <span className="input-group-text bg-light text-muted">
                          <LuMail size={18} />
                        </span>
                        <input
                          className="form-control bg-light"
                          type="email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          placeholder="name@example.com"
                          required
                          disabled={loading}
                        />
                      </div>
                    </div>

                    <div className="mt-4">
                      <button
                        className="btn-style w-100 py-2 fw-bold shadow-sm text-center d-flex align-items-center justify-content-center"
                        type="submit"
                        disabled={loading}
                        style={{ borderRadius: "8px" }}
                      >
                        {loading ? (
                          <span className="spinner-border spinner-border-sm me-2"></span>
                        ) : null}
                        {loading ? "Sending..." : "Send Reset Link"}
                      </button>
                    </div>
                  </form>

                  {message && (
                    <p
                      className={`text-center mt-3 small ${
                        isError ? "text-danger" : "text-success"
                      }`}
                    >
                      {message}
                    </p>
                  )}

                  <div className="text-center mt-4">
                    <Link to="/login" className="text-primary fw-semibold small">
                      ← Back to Login
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <BottomFooter />
    </div>
  );
}

export default ForgotPassword;
